import React, { useState, useEffect } from 'react'
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import Select from 'UI/Select'
import { Button } from 'react-bootstrap'
import { map, find, keys, without, isEmpty } from 'lodash'

const TrendsChart = ({trends, chartColumns, filterWidth = 200}) => {
  const [activeColumn, setActiveColumn] = useState('')
  const [columns, setColumns] = useState([])
  const [options, setOptions] = useState([])
  const [allVisible, setAllVisible] = useState(true);

  useEffect(() => {
    const result = map(chartColumns, column => ({ label: column.label, value: column.accessor }))
    setColumns(result);
    if(result.length > 0)
      setActiveColumn(result[0]);
  }, [chartColumns]);

  useEffect(() => {
    const series = map(trends, obj => ({
      name: obj.name,
      data: map(obj.data, d => [d.date, d[activeColumn.value]])
    }));

    const options = {
      title: {
        text: ''
      },
      chart: {
        height: 600
      },
      legend: {
        enabled: true,
        align: 'left',
        verticalAlign: 'middle',
        layout: 'vertical',
        y: 30,
        maxHeight: 550
      },
      rangeSelector: {
        buttons: [],
        inputEnabled: true, 
        inputPosition: {
            align: 'left'
        }
      },
      yAxis: {
        opposite: false
      },
      series: series,
      credits: {
        enabled: false
      }
    }
    setOptions(options)
  }, [activeColumn, trends])

  const toggleSeriesVisibility = () => {
    const newOptions = { ...options };
    newOptions.series.forEach(serie => {
      serie.visible = !allVisible;
    });
    setOptions(newOptions);
    setAllVisible(!allVisible);
  };

  return (
    <div className="row mt-3 position-relative">
      <div className="position-absolute top-1 left-8 col-auto" style={{ zIndex: 99 }}>
        <Button variant="outline-primary" onClick={toggleSeriesVisibility}>
          {allVisible ? 'Deselect All' : 'Select All'}
        </Button>
      </div>
      <div className="position-absolute top-1 right-8" style={{ zIndex: 99, maxWidth: parseInt(filterWidth) }}>
        <Select
          options={columns}
          value={activeColumn}
          onChange={(option) => setActiveColumn(option)}
        />
      </div>
      {
        !isEmpty(options) && (
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={'stockChart'}
            options={options}
          />
        )
      }
    </div>
  )
}

export default TrendsChart